import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import {
  AuthenticationResult,
  EventMessage,
  EventType,
} from '@azure/msal-browser';
import { RoleDto } from '@planetact/models/role-dto';
import { UserLocal } from '@planetact/models/user-local';
import { AuthMsalService } from '@planetact/services/authmsal.service';
import { UserService } from '@planetact/services/user.service';
import { Role } from '@planetact/shared/enums/enums';
import { filter, takeUntil, Subject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NotificationService } from '../../services/notification.service';
import { BreadcrumbService, Breadcrumb } from '../../services/breadcrumb.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less'],
})
export class IndexComponent implements OnInit, OnDestroy {
  isCollapsed: boolean = false;
  private readonly SIDEBAR_STATE_KEY = 'sidebarCollapsed';
  userLocal: UserLocal | null | undefined;
  roleUser: RoleDto | null = null;
  avatarText: string | null = '';
  isUser: boolean = false;
  isAdmin: boolean = false;
  isLoggedIn: boolean = false;
  public appVersion = environment.appVersion;
  unreadNotificationsCount: number = 0;
  breadcrumbs$: Observable<Breadcrumb[]>;
  private destroy$ = new Subject<void>();

  constructor(
    public userService: UserService,
    private router: Router,
    private authService: MsalService,
    private readonly _notificationService: NotificationService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly breadcrumbService: BreadcrumbService
  ) {
    this._notificationService.unreadNotificationsCount$
      .pipe(takeUntil(this.destroy$))
      .subscribe(count => {
        this.unreadNotificationsCount = count;
        Promise.resolve().then(() => {
          this._changeDetectorRef.markForCheck();
        });
      });

    this.breadcrumbs$ = this.breadcrumbService.breadcrumbs$;

    // Load saved sidebar state
    const savedState = localStorage.getItem(this.SIDEBAR_STATE_KEY);
    if (savedState !== null) {
      this.isCollapsed = savedState === 'true';
    }
  }

  ngOnInit(): void {
    if (this.authService.instance.getAllAccounts().length > 0) {
      this.isLoggedIn = true;
      this.avatarText = this.userService.generateAvatar();
      this.roleUser = this.userService.getLocalUserRole();
      if (this.roleUser?.roleName == Role.Admin) this.isAdmin = true;
      if (this.roleUser?.roleName == Role.User) this.isUser = true;
    } else {
      this.isLoggedIn = false;
    }
    this.loadNotificationsCount();
  }

  loadNotificationsCount(): void {
    if (this.isAdmin) {
      this._notificationService.getNotificationsCount().subscribe();
    } else {
      this._notificationService.getMyNotificationsCount().subscribe();
    }
  }

  logout() {
    this.userService.logout();
  }

  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed;
    localStorage.setItem(this.SIDEBAR_STATE_KEY, this.isCollapsed.toString());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
